module.exports = __webpack_public_path__ + "img/img99.55faa93c.png";